export default {
  changeUser (context, payload) {
    context.commit('CHANGE_', payload)
  },
  changeColor (context, payload) {
    context.commit('CHANGE_', payload)
  },
  changeColorSelecionado (context, payload) {
    context.commit('CHANGE_', payload)
  },
  changeLogo (context, payload) {
    context.commit('CHANGE_', payload)
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js